import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  useAsBillingAddress: true,
  isAddressEditable: false,
  isDeliveryProductsEditable: false,
  isPickUpProductsEditable: false,
  termsAccepted: true,
};

export const orderSlice = createSlice({
  name: "orderDetails",
  initialState,
  reducers: {
    setOrderDetails: (state, action) => {
      return { ...state, ...action.payload };
    },
    emptyOrderDetails: () => {
      return { ...initialState };
    },
  },
});

export const { setOrderDetails, emptyOrderDetails } = orderSlice.actions;

export default orderSlice;
